import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface
} from 'ngx-perfect-scrollbar';

import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { AppComponent } from "./app.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { FullLayoutComponent } from "./layouts/full/full-layout.component";

import { AuthService } from "./shared/auth/auth.service";
import { AuthGuard } from "./shared/auth/auth-guard.service";
import { WINDOW_PROVIDERS } from './shared/services/window.service';
import { AlertsService } from "./widget/alerts/alerts.service";
import { TemplateLayoutComponent } from "./website/template-layout/template-layout.component";
import { WnavbarComponent } from "./website/wnavbar/wnavbar.component";
import { LanguageService } from "./service/language.service";
import { NgPipesModule } from "ngx-pipes";
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { BrowserModule } from "@angular/platform-browser";


var firebaseConfig = {
  apiKey: "AIzaSyDsZ1siXR6OJjMvfV3QW5YnSiYQCGAaJ9U",
  authDomain: "dexker-aeff5.firebaseapp.com",
  databaseURL: "https://dexker-aeff5.firebaseio.com",
  projectId: "dexker-aeff5",
  storageBucket: "dexker-aeff5.appspot.com",
  messagingSenderId: "698276251613",
  appId: "1:698276251613:web:4447e54d9b6e6e90675834",
  measurementId: "G-EMV4PNK8B5"
};


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent, FullLayoutComponent, ContentLayoutComponent, TemplateLayoutComponent, WnavbarComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    NgbModule,
    NgxSpinnerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    PerfectScrollbarModule,
    NgPipesModule,
    RecaptchaV3Module
  ],
  providers: [
    AuthService,
    AuthGuard,
    AlertsService,
    LanguageService,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LfwQy4pAAAAAG4aUwsGKEocZUFuFcondQv_JvC-' },
    WINDOW_PROVIDERS
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
